import { createBaseQuery } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'

const vendorApi = tokenSlice.injectEndpoints({
  reducerPath: 'vendor',
  baseQuery: createBaseQuery(),
  tagTypes: ['Vendor'],
  endpoints(builder) {
    return {
      // GET

      getVendorAll: builder.query({
        query: () => ({
          url: 'Vendor/Vendors',
          method: 'GET',
        }),
        providesTags: ['Vendor'],
      }),

      getSupplierCodes: builder.query({
        query: () => ({
          url: 'Supplier/GetSupplierCodes',
        }),
        providesTags: ['Vendor'],
      }),

      getVendorRFQList: builder.query({
        query: (vendorCode) => ({
          url: `Vendor/GetVendorRFQList/${vendorCode}`,
          method: 'GET',
        }),
        providesTags: ['Vendor'],
      }),

      getVendorCard: builder.query({
        query: (id) => ({
          url: `Vendor/Get/${id}`,
          method: 'GET',
        }),
        providesTags: ['Vendor'],
      }),

      getVendorFilters: builder.query({
        query: () => ({
          url: 'Vendor/Filters',
        }),
        providesTags: ['Vendor'],
      }),

      // POST
      postVendorByTax: builder.mutation({
        query: (taxId) => ({
          url: `Vendor/GetByTax?taxId=${taxId}`,
          method: 'POST',
        }),
        invalidatesTags: ['Vendor'],
      }),

      postVendorRfqChangeStatus: builder.mutation({
        query: (data) => ({
          url: `Vendor/RFQVendorResponseChangeStatus`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postVendorSendToApprove: builder.mutation({
        query: (data) => ({
          url: 'Vendor/SendToApprove',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postGetVendorDraft: builder.mutation({
        query: (data) => ({
          url: 'Vendor/GetDraft',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postGetVendorWFA: builder.mutation({
        query: (data) => ({
          url: 'Vendor/GetWFA',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postGetVendorApprove: builder.mutation({
        query: (data) => ({
          url: 'Vendor/GetApproved',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postGetVendorReject: builder.mutation({
        query: (data) => ({
          url: 'Vendor/GetRejected',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postGetVendorHeld: builder.mutation({
        query: (data) => ({
          url: 'Vendor/GetHeld',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postGetVendorAll: builder.mutation({
        query: (data) => ({
          url: 'Vendor/GetAll',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postVendorChangeStatus: builder.mutation({
        query: (data) => ({
          url: 'Vendor/Approve',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postVendorSave: builder.mutation({
        query: (data) => ({
          url: 'Vendor/Save2',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      postHasVendorName: builder.mutation({
        query: (data) => ({
          url: 'Vendor/HasVendorName',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      //Delete

      deleteVendor: builder.mutation({
        query: (data) => ({
          url: 'Vendor/Delete',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),

      transferToIntegration: builder.mutation({
        query: (data) => ({
          url: 'Vendor/TransferToIntegration',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Vendor'],
      }),
    }
  },
})

export const {
  useGetSupplierCodesQuery,
  // useGetVendorByTaxQuery,
  usePostVendorByTaxMutation,
  useGetVendorAllQuery,
  useGetVendorFiltersQuery,
  usePostVendorSendToApproveMutation,
  usePostGetVendorAllMutation,
  usePostGetVendorDraftMutation,
  usePostGetVendorApproveMutation,
  usePostGetVendorRejectMutation,
  usePostGetVendorHeldMutation,
  usePostGetVendorWFAMutation,
  usePostVendorChangeStatusMutation,
  useGetVendorCardQuery,
  usePostVendorSaveMutation,
  useDeleteVendorMutation,
  useGetVendorRFQListQuery,
  usePostHasVendorNameMutation,
  usePostVendorRfqChangeStatusMutation,
  useTransferToIntegrationMutation,
} = vendorApi

export { vendorApi }